import Box from "@mui/material/Box";
import { useLocation } from "react-router";
import Header from "../Header";

/**
 * InvalidRoutePage Component
 *
 * This component displays a message indicating that the requested page does not exist.
 */
function InvalidRoutePage() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const readPDF = params.get("withPdf") === "PDF";

  return (
    <>
      <Header showMenu={false} />
      {!readPDF ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="calc(100vh - 50px)"
        >
          <h1>該当のページは存在しません。</h1>
        </Box>
      ) : (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          paddingTop={10}
          gap={18}
        >
          <Box>
            <img src="/img/login/yhbb_login_top.png" alt="YHBB invalid" />
          </Box>
          <h1>ページが表示できません。</h1>
        </Box>
      )}
    </>
  );
}

export default InvalidRoutePage;
